import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useParams,
  useLocation
} from 'react-router-dom';
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Dashboard from "./pages/Dashboard";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import UTMHandlerHealth from "./pages/UTMHandlerHealth";
import UTMHandlerMobile from "./pages/UTMHandlerMobile";
import usePageTracking from "./utils/usePageTracking";
import HealthTermsAndConditions from "./pages/HealthTermsAndConditions";
import HealthCompaignTandC from "./pages/HealthCompaignTandC";
import MobileTermsAndConditions from "./pages/MobileTermsAndConditions";
import MobileCompaignTandC from "./pages/MobileCompaignTandC";

const ConditionalUTMHandler = () => {
  const { id } = useParams();

  if (id === "1") {
    return <UTMHandlerHealth />;
  } else if (id === "2") {
    return <UTMHandlerMobile />;
  } else {
    return <Dashboard />;
  }
};

// 👇 Wrap routing and tracking inside a component under <Router>
const AppRoutes = () => {
  usePageTracking(); // ✅ now inside <Router> context

  return (
    <Routes>
      <Route path="/" element={<Dashboard />} />
      <Route path="/:id" element={<ConditionalUTMHandler />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/health-terms-and-conditions" element={<HealthTermsAndConditions />} />
      <Route path="/mobile-terms-and-conditions" element={<MobileTermsAndConditions />} />
      <Route path="/health-compaign-terms-and-conditions" element={<HealthCompaignTandC />} />
      <Route path="/mobile-compaign-terms-and-conditions" element={<MobileCompaignTandC />} />
    </Routes>
  );
};

const App = () => {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
};

export default App;
